import { useTranslation } from 'next-i18next'

import ProductCardButton from '~/shared/components/TutorOnDemandProductCards/components/ProductCardButton/ProductCardButton.component'
import ROUTES from '~/shared/constants/routes.const'
import { ButtonPrimary } from '~/components/Buttons'
import { Breakpoint, useCheckBreakpoint } from '~/utils'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

import CompetencyRequirements from './CompetencyRequirements'
import Hero from './Hero/Hero'
import PricesList from './PricesList/PricesList'
import Support from './Support'
import Testimonials from './Testimonials/Testimonials'
import WhyChoose from './WhyChoose'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '140px' }]

export default function TutorOnDemand(): React.ReactElement {
  const { t } = useTranslation(['generics', 'tutorOnDemand'])
  const pxCxs = 'px-4 md:px-8 xl:px-12'
  const isDesktop = useCheckBreakpoint({ gt: Breakpoint.SM })

  return (
    <article>
      <Hero className="pt-4" />
      <Support className={`py-16 mx-auto w-full ${pxCxs}`} />

      <Testimonials className={`my-5 ${pxCxs}`} />

      <div className={`w-full my-12 ${pxCxs}`}>
        <ProductCardButton className="mx-auto" href={ROUTES.BOOKING_FOR_SELF} label={t('generics:book')} />
      </div>

      <WhyChoose className={`pt-10 ${pxCxs}`} />

      <CompetencyRequirements className={`max-auto ${pxCxs}`} />

      <div className={`w-full my-12 pt-6 ${pxCxs}`}>
        <ProductCardButton className="mx-auto" href={ROUTES.BOOKING_FOR_SELF} label={t('generics:book')} />
      </div>

      <PricesList className={`py-6 sm:py-16 xl:my-20 ${pxCxs}`} />

      <div className="relative mt-8">
        {!isDesktop && (
          <ResponsiveImage
            alt={t('tutorOnDemand:landingPage.doYouNeedHelp')}
            height={200}
            imageClassName="mx-auto"
            imageWidths="140"
            mediaQuery={mediaQuery}
            srcKey="mentor-on-demand/home/help/beanstalk-question-mark.png"
            width={140}
          />
        )}
        <Support className={`py-6 ${pxCxs}`} showAvatar={isDesktop} />
        <div className="sm:absolute w-full sm:bottom-28 sm:-left-20 px-4 pb-6 z-20">
          <ButtonPrimary
            className="mx-auto sm:px-28 max-w-[370px]"
            href={ROUTES.TUTOR_ON_DEMAND_INFORMATION}
            isFullWidth
            size="medium"
          >
            {t('generics:moreInformation')}
          </ButtonPrimary>
        </div>
      </div>
    </article>
  )
}
